<template>
  <img :src="imageSrc" v-bind="$attrs" ref="image"/>
</template>

<script>
export default {
  props: ['src', 'srcPlaceholder', 'intersectionOptions'],
  data() {
    return {
      observer: null,
      isIntersected: false,
    }
  },
  computed: {
    imageSrc() {
      return this.isIntersected ? this.src : this.srcPlaceholder;
    }
  },
  methods: {
  },
  mounted() {
    if("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver((entries) => {
        if(entries.some((entry) => entry.isIntersecting)) {
          this.isIntersected = true;
          this.observer.disconnect();
        }
      }, this.intersectionOptions);
      this.observer.observe(this.$refs.image);
    }
  },
  unmounted() {
    if("IntersectionObserver" in window && this.observer) {
      this.observer.disconnect();
    }
  }
}
</script>
